import { render, staticRenderFns } from "./qd.vue?vue&type=template&id=ca12235c"
import script from "./qd.vue?vue&type=script&lang=js"
export * from "./qd.vue?vue&type=script&lang=js"
import style0 from "./qd.vue?vue&type=style&index=0&id=ca12235c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports